import { USER_EVENTS } from '@shared/core/user-events'
import { ALERT_CAMPAIGN_IDS, ALERT_CAMPAIGN_PRIORITIES, ALERT_CAMPAIGN_SEEN_EVENTS } from '../alerts.constants'
import { AlertCampaign } from '../alerts.types'

export const typeformReviewModalCampaign: AlertCampaign = {
  id: ALERT_CAMPAIGN_IDS.TYPEFORM_REVIEW,
  priority: ALERT_CAMPAIGN_PRIORITIES.TYPEFORM_REVIEW,
  seenEventName: ALERT_CAMPAIGN_SEEN_EVENTS[ALERT_CAMPAIGN_IDS.TYPEFORM_REVIEW],
  isEligible: (context) => {
    if (context.profile === null) {
      return false
    }

    if (
      context.profile.usage_mode !== 'customer' ||
      context.userEvents.has(USER_EVENTS.REVIEW_FIRST_EVENT_MODAL_SEEN)
    ) {
      return false
    }

    return context.profile.reminders_sent_during_billing_cycle > 5
  },
}
